module.exports = __webpack_public_path__ + "static/media/Marios_Aristodemou.dbb8b5b9.png";